import styled, { createGlobalStyle } from 'styled-components'

export const ProgramSection = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;  
  align-items: ${props => (props.program ? 'flex-end' : 'center')};
  z-index: 10;
  margin-top: 75px;
  margin-left: 50%;
  width: 50%;
  position: relative;
  @media (max-width: 1200px) {
      margin-left: 0;
      width: 100%;    
  }
  @media (max-width: 768px) {
    margin-top: 0;
  }
  .programSectionWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .routesListWrapper {
    align-self: center;
    @media (max-width: 700px) {
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  .sideTear {
    position: absolute;
    right: -10px;
    left: -140px;
    top: -100px;
    width: 300px;
    height: calc(100% + 350px);
    background: url("/static/images/vertical-map-background.png") repeat-y;
    z-index: -1;
  }
  .avatarSvgPlaceholder {
    border-radius: 50px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .emptyProgramMessage,
  .emptyProgramHeader {
    letter-spacing: 2px;
    text-align: center;
    color: #ffffff;
  }
  .emptyProgramHeader {
    font-family: StolzlMedium, serif;
    font-size: 20px;
    line-height: 1.5;
    width: 484px;
    height: 60px;
    @media (max-width: 768px) {
      width: 250px;
      font-size: 16px;
      line-height: 1.88;
      letter-spacing: 2px;
    }
  }
  .emptyProgramMessage {
    font-family: StolzlLight, serif;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.88;
    width: 385px;
    height: 94px;
    margin-top: 35px;
    @media (max-width: 700px) {
      width: 250px;
      font-size: 14px;
      line-height: 1.57;
    }
  }
  .emptyProgram {
    align-self: center;
    margin: 60px 0 40px 0;
    width: 628px;
    height: 381px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    position: relative;
    @media (max-width: 1200px) {
      margin-top: 20px;
    }
    @media (max-width: 768px) {
      margin-top: 0;
      margin-bottom: 30px;
      width: 335px;
      height: 313px;
    }
  }
  .emptyProgram img {
    width: 628px;
    height: 381px;
    position: absolute;
    z-index: -1;
    @media (max-width: 700px) {
      width: 335px;
      height: 313px;
    }
  }
  .routesSection {
    max-width: 628px;
    width: 100%;
    margin-top: 50px;
    z-index: 1;
    position: relative;
  }
  .noRoutesYet {
    text-align: center;
    width: 500px;
  }
  .scrollContainer {
    width: 666px;
    left: -19px;
    position: relative;
    @media (max-width: 700px) {
      width: 300px;
      left: 0;
      margin: auto;
    }
  }
  .profile {
    max-width: 839px;
    width: 100%;
    @media (max-width: 800px) {
      max-width: 100%;    
    }
    //@media (max-width: 1200px) {
    //  width: calc(100% - 30px);    
    //}
  }
  .partner {
    max-width: 839px;
    width: 100%;
  }
  .infiniteScroll {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 20px;
    .routeCard {
      margin-bottom: 26px;
    }
  }
  .programPageStyle {
    :nth-child(2n) {
      margin-left: 26px;
    }
    @media (max-width: 700px) {
      :nth-child(2n) {
        margin-left: 0;
      }
    }
    .routeCard {
      max-width: 300px;
    }
  }
  .header {
    font-family: StolzlMedium, serif;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 2px;
    color: #000;
    text-transform: uppercase;
    margin: 0 0 45px;
    @media (max-width: 400px) {
      font-size: 16px;
    }
  }
  .programList {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
  }
  
  .programListWrapper {
    padding-left: 40px;
    width: 100%;
    position: relative;
  }
  
  .programListWrapper > div {
    :first-child {
      margin-top: 10px;
    }
    :last-child {
      margin-bottom: 45px;
    }
  }
`


export const GlobalStyle = createGlobalStyle`
  .ClosingModal_Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.70);
    z-index: 10;
  }
  .ClosingModal_Content {
    position: absolute;
    max-height: 299px;
    display: flex;
    justify-content: center;
    width: 880px;
    height: 100%;
    top: calc(50% - 170px);
    left: calc(50vw - 440px);
    background: #fff;
    -webkit-overflow-scrolling: touch;
    border-radius: 10px;
    outline: none;
    text-align: center;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #000;
    @media (max-width: 930px) {
      width: 335px;
      max-height: 330px;
      top: calc(50% - 230px);
      left: calc(50vw - 167px);
    }
    h3 {
      font-family: StolzlMedium, serif;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.5;
      text-transform: uppercase;
    }
    .closeWrapper {
      font-family: StolzlLight, serif;
      max-width: 685px;
      font-size: 16px;
      line-height: 1.88;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 930px) {
        justify-content: flex-end;
      }
    }
    .sureDelete { 
      max-width: 685px;
      margin-bottom: 50px;
      @media (max-width: 930px) {
        max-width: 250px;
        font-size: 14px;
        margin-bottom: 20px;
        letter-spacing: normal;
        line-height: 1.57;
      }
    }
    .modalButtons {
      display: flex;
      @media (max-width: 930px) {
        flex-direction: column;
        margin-bottom: 33px;
      }
    }
    .modalButtons > div {
      :first-child {
        margin-right: 60px;
      }
      @media (max-width: 930px) {
        :first-child {
          margin-right: 0;
        }
      }
      @media (max-width: 700px) {
        :first-child {
          margin-bottom: 10px;
        }
      }
    }
  }
`

export const ProgramList = styled.div`
  display: flex;
  justify-content: space-between;
  .counts {
    margin-top: 32px;
    font-family: StolzlMedium, serif;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
  }
  .duration {
    text-transform: uppercase;
    color: #933ec5;
    margin-right: 75px;
  }
  .description {
    margin-right: 75px;
    margin-top: 25px;
    font-family: StolzlLight, serif;
    font-size: 16px;
    line-height: 1.88;
  }
  .linksDiv {
    margin-top: 10px;
  }
  .descriptionLink {
    font-family: StolzlLight, serif;
    font-size: 16px;
    line-height: 1.88;
    letter-spacing: 2px;
    color: #933ec5;
  }
  .widgets {
    margin-top: 30px;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .starWidget {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    margin-right: 75px;
  }
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
  @media (max-width: 730px) {
    margin-top: 10px;
  } 
  .programNav {
    display: flex;
    align-items: center;
    height: 60px;
    margin-top: 58px;
    margin-bottom: 40px;
    @media (max-width: 1200px) {
      margin: 0 0 20px 20px;
    }
  }
  .bottomSocials {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }
  .partnerDescription {
    letter-spacing: 2px;
    margin-top: 30px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    @media (max-width: 900px) {
      margin-left: 20px;
    }
  }
  .navButton {
    padding: 0;
    border: 0;
    background: 0;
    outline: none;
    margin-left: auto;
    @media (max-width: 730px) {
      margin-left: 0;
    }
  }
  .customHint {
    top: -63px !important;
    left: 14px !important;
    position: absolute;
  }
  .customHintContent {
    position: absolute;
    opacity: 0;
    transition: opacity ease 1s;
    width: 324px;
    height: 42px;
    border-radius: 5px;
    background-color: rgba(210, 218, 228, 0.21);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hintText {
    opacity: 0.3;
    font-family: StolzlLight, serif;
    font-size: 14px;
    line-height: 1.57;
  }
  .active {
    opacity: 1;
  }
  .margin {
    margin: 0;
  }
  .navIcon {
    cursor: pointer;
    margin-top: 0;
    transition-duration: 0.2s;
    @media (max-width: 730px) {
      :not(:last-child) {
        margin-right: 24px;
      }
      :first-child {
        margin-left: 20px;
      }
      :last-child {
        margin-left: auto !important;
      }
    }
    :not(:last-child) :not(:first-child) {
      margin-right: 24px;
    }
    :last-child {
      margin-left: 42px;
      margin-right: 30px;
      @media (max-width: 1250px) {
        margin-left: 25px;      
      }
    }
    :hover {
      transform: scale(1.3);
    }
  }
  .programCounts {
    margin-top: 32px;
    font-family: StolzlMedium, serif;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    @media (max-width: 730px) {
      font-size: 16px;
      line-height: 1.88;
      letter-spacing: 2px;
      margin-top: 16px;
      justify-content: end;
    }
  }
  .center {
    @media (max-width: 730px) {
      justify-content: center;
    }
  }
  .programDuration {
    text-transform: uppercase;
    color: #933ec5;
    margin-right: 75px;
    @media (max-width: 730px) {
      margin-right: 0;
    }
  }
  .description {
    margin-right: 75px;
    margin-top: 25px;
    font-family: StolzlLight, serif;
    font-size: 16px;
    line-height: 1.88;
    @media (max-width: 730px) {
      font-size: 14px;
      line-height: 1.57;
      margin-right: 15px;
    }
  }
  .linksDiv {
    margin-top: 10px;
  }
  .descriptionLink {
    font-family: StolzlLight, serif;
    font-size: 16px;
    line-height: 1.88;
    letter-spacing: 2px;
    color: #933ec5;
  }
  .widgets {
    margin-top: 30px;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 730px) {
      .icon {
        height: 30px !important;
        width: 30px !important;
      }
      margin: 20px;
    }
  }
  .starWidget {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    margin-right: 75px;
    @media (max-width: 730px) {
      margin: 0;
    }
  }
  .programDuration,
  .artistsCount {
    text-transform: uppercase;
  }
  .artistsCount {
    @media (max-width: 730px) {
      letter-spacing: 1.4px;
      :after {
        content: ' / ';
      }
    }
  }
  .routeFrom {
    font-family: StolzlLight, serif;
    font-size: 20px;
    @media (max-width: 730px) {
      font-size: 14px;
      line-height: 1.57;
    }
  }
  .avatar {
    border-radius: 50px;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.1);
    background-color: #ffffff;
    width: 100px;
    height: 100px;
    object-fit: cover; 
  }
  .routeName {
    width: 100%;
    margin-top: 10px;
    text-transform: uppercase;
    font-family: StolzlMedium, serif;
    font-size: 50px;
    line-height: 1.2;
    @media (max-width: 730px) {
      width: 100%;
    }
    @media (max-width: 500px) {
      font-size: 20px !important;
      line-height: 1.5 !important;;
      letter-spacing: 1px !important;
      text-transform: none !important;
    }
  }
  .profileSection {
    max-width: 728px;
    width: 100%;
    align-self: flex-end;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    @media (max-width: 1400px) {
      max-width: 599px;
    }
    @media (max-width: 1000px) {
      margin-left: 40px;
    }
    @media (max-width: 730px) {
      margin-top: 0;
      margin-left: 0;
    }
  }
  .avatarSection {
    display: flex;
    align-items: center;
    @media (max-width: 730px) {
      flex-direction: column;
    }
  }
  .profileName {
    margin-left: 30px;
    @media (max-width: 730px) {
      margin-top: 18px;
      margin-left: 0;
      width: 350px;
      text-align: center;
    }
  }
  .emailSvg {
    width: 50px;
    height: 50px;
    transition-duration: 0.2s;
    :hover {
      transform: scale(1.3);
    }
    @media (max-width: 500px) {
      width: 30px;
      height: 30px;
      .injected-svg {
        width: 30px;
        height: 30px;
      }
    }
  }
  .profileRouteName {
    :first-child {
      margin-bottom: 15px;
    }
    font-size: 20px;
    text-transform: uppercase;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 500px) {
      font-size: 14px;
      line-height: 1.57;
    }
  }
  .partnerLogo {
    position: relative;
    width: 100%;
    height: 40%;
    left: -38px;
    object-fit: cover;
    top: -66px;
  }
  .map {
    position: fixed;
    top: 0;
    width: 50%;
    height: 1160px;
    margin-bottom: -59px;
  }
  
  .mapWidget {
    top: -50px;
    .locationSvg {
      width: 50px;
      height: 50px;
    }
  }
`
